import React, { useEffect } from 'react';
import { useFileManagementUrlHandler } from '../hooks/useFileManagementUrlHandler';
import FolderAndFileManagement from './FolderAndFileManagement';
import useRecentVisits from '@rd-web-markets/shared/dist/hooks/useRecentVisits';
const SelectedModelFileManagement = () => {
  const [key, goToTab, goToFolderQuery, fileUploaderUsers, modelName, modelType, modelId, getFileUploadersAndVirtualFolderPath] = useFileManagementUrlHandler();
  const {
    addRecentCompanyId
  } = useRecentVisits();
  useEffect(() => {
    addRecentCompanyId(modelId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelId]);
  return /*#__PURE__*/React.createElement(FolderAndFileManagement, {
    targetModelId: modelId,
    type: modelType,
    modelName: modelName,
    goToFolderQuery: goToFolderQuery,
    fileUploaderUsers: fileUploaderUsers,
    getFileUploadersAndVirtualFolderPath: getFileUploadersAndVirtualFolderPath
  });
};
export default SelectedModelFileManagement;